import JanelaColetaModel from "../models/janelaColetaModel";
import nfetch from "../utils/events/nfetch";

import { iServiceCached } from "./base/iServiceCached";

class JanelaColetaService extends iServiceCached<JanelaColetaModel> {
    constructor() {
        super("JanelaColeta");
    }

    public getByFranquia(): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetByFranquia`, {
            credentials: "same-origin",
        });
    }

    public updateModels(models: JanelaColetaModel[]): Promise<Response> {
        return nfetch(`/${this.controllerName}/UpdateModels`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify(models),
        });
    }
}

export default new JanelaColetaService();
